import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SideCard from '../StubPageSideCard';
import SimpleModal from '../Modal';
import ImageGallery from '../ImageGallery';
import { useTranslation } from '../../src/i18n';
import { colors } from '../../constants/styleConstants';

import NextLink from '../NextLink';
import { TP } from '../../constants/consts';
import ImageTag from '../ImageTag';

const useStyles = makeStyles(() => ({
  imagesBox: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  sideCard: {
    marginBottom: 20,
  },
  imageBtn: {
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    background: 'transparent',
    lineHeight: 0,
    '&:focus': {
      outline: 'none',
    },
  },
  img: {
    height: '90px',
    margin: '0 2px 5px',
    maxWidth: '100%',
    objectFit: 'cover',
    borderRadius: '4px',
    objectPosition: 'top',
  },
  rightArrow: {
    fontSize: '1.1rem',
    color: colors.blueChip,
  },
}));

const ImageGalleryView = ({ title, images, maxCountImages, tabName, goToTab }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [isModalOpen, setModalOpen] = React.useState(false);
  const [chosenImage, setImageNumber] = React.useState(0);

  const openModal = imageNumber => {
    setImageNumber(imageNumber);
    setModalOpen(true);
  };

  const closeModal = () => {
    setImageNumber(0);
    setModalOpen(false);
  };

  return (
    <SideCard
      title={t(title)}
      className={classes.sideCard}
      titleActionComponent={
        <a onClick={() => goToTab('images')} className={classes.link}>
          <ArrowForwardIcon className={classes.rightArrow} />
        </a>
      }
      tabName={tabName}
    >
      <div className={classes.imagesBox}>
        {images.slice(0, maxCountImages).map((image, index) => (
          <button type="button" className={classes.imageBtn} key={index} onClick={() => openModal(index)}>
            <ImageTag className={classes.img} src={image.srcPreview} alt={image.alt || 'image'} />
          </button>
        ))}
        <SimpleModal isModalOpen={isModalOpen} onClose={closeModal} disableBackdropClick>
          <ImageGallery images={images} chosenImage={chosenImage} />
        </SimpleModal>
      </div>
    </SideCard>
  );
};

ImageGalleryView.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      srcPreview: PropTypes.string,
      srcView: PropTypes.string,
      alt: PropTypes.string,
      tags: PropTypes.arrayOf(
        PropTypes.shape({
          linkText: PropTypes.string,
          linkProps: PropTypes.oneOfType([PropTypes.shape({ ...NextLink.propTypes }), PropTypes.func]),
        }),
      ),
      descriptionTitle: PropTypes.string,
      musicalWork: PropTypes.string,
      musicalWorkLinkProps: PropTypes.shape(NextLink.propTypes),
      company: PropTypes.string,
      companyLinkProps: PropTypes.shape(NextLink.propTypes),
    }),
  ).isRequired,
  title: PropTypes.string,
  maxCountImages: PropTypes.number,
  tabName: PropTypes.string,
  goToTab: PropTypes.func,
};

ImageGalleryView.defaultProps = {
  title: `${TP}.m_IMAGES`,
};

export default ImageGalleryView;
